import { Text } from '@descope/page-editor-components';
import { Box } from '@mui/material';
import { clamp } from 'lodash';
import React, { useCallback, useMemo } from 'react';
import { FONT_SIZES, FONT_SIZE_LIMIT, FONT_WEIGHTS } from '../constants';
import { TypographyVariants } from '../types';
import TypographyAutocomplete from '../TypographyAutocomplete';
import TypographyFontFamilyAutocomplete from './TypographyFontFamilyAutocomplete';

type Props = {
	fontFamilies: string[];
	values: Record<string, string>;
	setVariant: (path: string, value: string) => void;
	variant: TypographyVariants;
};

export default ({ fontFamilies, values, setVariant, variant }: Props) => {
	const setFontSize = useCallback(
		(v: string) =>
			setVariant('font-size', clamp(Number(v), 4, FONT_SIZE_LIMIT).toString()),
		[setVariant]
	);

	const getFontWeightLabel = useCallback(
		(v: string) => FONT_WEIGHTS[v as keyof typeof FONT_WEIGHTS],
		[]
	);

	const fontWeightOptions = useMemo(() => Object.keys(FONT_WEIGHTS), []);

	const setFontWeight = useCallback(
		(v: string) => setVariant('font-weight', v),
		[setVariant]
	);

	return (
		<Box paddingY={2} paddingX={4} sx={{ '& > *': { marginBottom: 3 } }}>
			<TypographyAutocomplete
				data-testid="typography-variant-font-size"
				label={intl.tr('styleEditor.typography.variant.font.size')}
				value={values?.['font-size']}
				options={FONT_SIZES}
				setValue={setFontSize}
				freeSolo
				number
			/>

			<TypographyFontFamilyAutocomplete
				fontFamilies={fontFamilies}
				values={values}
				setVariant={setVariant}
			/>

			<TypographyAutocomplete
				data-testid="typography-variant-font-weight"
				label={intl.tr('styleEditor.typography.variant.font.weight')}
				value={values?.['font-weight']}
				options={fontWeightOptions}
				getOptionLabel={getFontWeightLabel}
				setValue={setFontWeight}
			/>

			<Text
				className={`descope-typography-${variant}`}
				style={{ color: 'currentcolor' }}
			>
				lorem ipsum dolor sit amet consectetur adipiscing elit sed do eiusmod
				tempor
			</Text>
		</Box>
	);
};
